import React, { Component } from 'react';
import _ from 'lodash';
import { Rnd } from "react-rnd";
import moment from 'moment';
import FaCircle from 'react-icons/lib/fa/circle';
import SoundNotification from "../NotificationSound";
import MdArrowDownward from "react-icons/lib/md/arrow-downward";
import ReactTooltip from "react-tooltip";
import IconSpinner from "react-icons/lib/fa/spinner";
import { validateUrl } from "../../utils/validator";
import { connect } from "react-redux";
import { setCurrentDentist, eventOnRead, getChatDentists } from "../../containers/Chat/actions";

const style = {
    display: "flex",
    alignItems: "center",
    position: 'fixed',
    justifyContent: "center",
    zIndex: '9999',
};
class AdminChatBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentDentist: {},
            message: '',
            showDentistList: true,
            searchedValue: '',
            dentists: [],
            searchedDentist: {},
            width: 300,
            height: 400,
            x: window.innerWidth - 320,
            y: window.innerHeight - 482
        }
    }
    componentDidUpdate(prevProps) {
        if (this.messagesEnd && ((!this.props.isMinimized && prevProps.isMinimized)
            || (this.props.adminIsOnline && !prevProps.adminIsOnline)
            || (this.props.addedMessage && !prevProps.addedMessage)
            || (!_.isEqual(this.props.messages, prevProps.messages) && this.props.isScrolledToBottom))) {
            this.props.scrollToBottom(this.messagesEnd);
        }
        if (prevProps.chatData.chatDentists !== this.props.chatData.chatDentists) {
            this.setState({
                dentists: this.props.chatData.chatDentists,
            })
        }
        if ((prevProps.messages !== this.props.messages && !this.state.showDentistList && !this.props.isMinimized) ||
            (!this.props.isMinimized && prevProps.isMinimized && !this.state.showDentistList)) {
            this.props.readMessages();
        }
    }

    componentDidMount() {
        this.props.getChatDentists();
        window.addEventListener('resize', this.handleWindowResize);
    }

    openMessageBlock = (currentDentist) => {
        this.props.setCurrentDentist(currentDentist);
        this.props.getMessages(currentDentist.id, 0);
        this.setState({
            showDentistList: false
        });
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.chatData.connected && nextProps.chatData.connected && this.props.chatData.maxChat !== nextProps.chatData.maxChat) {
            this.props.eventOnRead();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize',this.handleWindowResize)
    }

    openDentistsList = () => {
        this.setState({
            showDentistList: true,
            dentists: this.props.chatData.chatDentists
        });

        this.props.getChatDentists();
    }

    minimizedBtnClick = () => {
        this.props.changeCalendarState();
        this.props.getChatDentists();
        this.props.toggleMinimizedState();
    }

    renderMinimizedChat = () => {
        const {
            numberOfMessages,
        } = this.props;
        return <div className="chat__minimized" onClick={this.minimizedBtnClick}>
            <button className="btn btn-chat">
                <span className="kr kr-chat" />
                 {numberOfMessages ?
                    <span className="message-notification-user badge badge-danger">{numberOfMessages}</span>
                     : null
                 }
            </button>
        </div>;
    };

    handleWindowResize = () => {
        this.setState(
            {x: window.innerWidth - 320,y: window.innerHeight - 420}
        )
    }

    renderLoader = () => {
        return <h1 className="text-center chat__loader"><IconSpinner size={20} className="spinner" /></h1>;
    };

    renderLoadMessages = () => {
        const { noMoreMessages } = this.props;
        return <button className="btn-link btn-link-black load__more-btn"
            onClick={this.handleLoadMore}>{noMoreMessages ? 'No More Messages' : 'Load More'}</button>;
    };

    renderMessages = () => {
        const {
            messages,
        } = this.props;
        const { chatData: { currentDentist } } = this.props;
        return messages.sort((a, b) => (new Date(a.created_at) - new Date(b.created_at))).map(message => (
            <div key={message.id} className="message-box-holder">
                <div
                    className={`message-box ${currentDentist.id === message.from ? 'chat__messages-received' : ''}
                                     `} dangerouslySetInnerHTML={{ __html: validateUrl(message.message, 'btn-link-black') }}>
                </div>
                <div
                    className={`${currentDentist.id === message.from ? 'message-sender-sent' : 'message-sender'}`}>
                    {moment(message.created_at).calendar(null, {
                        sameDay: 'HH:mm',
                        nextDay: '[Tomorrow] HH:mm',
                        nextWeek: 'ddd',
                        lastDay: '[Yesterday] HH:mm',
                        lastWeek: 'ddd HH:mm',
                        sameElse: 'DD MMM HH:mm'
                    })}
                </div>
            </div>
        ))
    };

    handleLoadMore = () => {
        const { chatData: { currentDentist } } = this.props;
        if (!this.props.noMoreMessages) {
            this.props.getMessages(currentDentist.id, this.props.chatData.messages.reduce((prev, curr) => prev.id < curr.id ? prev : curr).id);
        }
    };

    sendMessage = (e) => {
        const { message } = this.state;
        const { chatData: { currentDentist } } = this.props
        if ((e.key === 'Enter' && !e.shiftKey) || e.currentTarget.type === 'submit') {
            e.preventDefault();
            this.props.addNewMessage(message, currentDentist.id)
            this.setState({
                message: '',
            })
        }
    };

    handleMessageChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    setOnlineStatus = () => {
        const { chatData: { onlineUsers, currentDentist } } = this.props;
        const isOnline = onlineUsers.find(onlineUser => (
            +onlineUser === currentDentist.id
        ));

        return (<FaCircle
            className="chat__maximized-partner__status"
            color={isOnline ? "#54D043" : "#888888"}
        />)

    }

    renderMaximizedChat = () => {
        const {
            messages,
            loadingMessages,
            isScrolledToBottom,
            adminIsOnline,
            chatData: { currentDentist }
        } = this.props;
        const { message } = this.state;

        return (

            <div className="chat__maximized" style={{backgroundColor: '#fff' }}>
                <div className="chat__maximized-title">
                    <div
                        className="back-to-list"
                        onClick={this.openDentistsList}
                    >
                        <span className="kr kr-arrow" />
                    </div>
                    <div className="chat__maximized-partner">
                        {this.setOnlineStatus()}

                        {`${currentDentist.first_name} ${currentDentist.last_name}`}
                    </div>
                    <div className="chat__maximized-icons">
                        <span
                            className="kr kr-close"
                            onClick={this.props.toggleMinimizedState}
                        />
                    </div>
                </div>
                <div onMouseDown={(e) => {e.stopPropagation()}} className="chat__maximized-body">

                    <div className={`chat__maximized__messages ${adminIsOnline ? '' : 'chat__maximized__messages-offline'}`}
                        // style={{ height: '290px' }}
                        onScroll={() => this.props.handleScroll(this.messagesEnd)} ref={(el) => {
                            this.messagesEnd = el;
                        }}
                    >
                        {loadingMessages ?
                            this.renderLoader() : this.renderLoadMessages()
                        }

                        {messages && currentDentist ? this.renderMessages() : null}
                        {!isScrolledToBottom ? <button
                            data-tip="Go to bottom"
                            onClick={() => this.props.scrollToBottom(this.messagesEnd)} className="btn btn-fab btn-sm button__arrow__down button__arrow__down-user">
                            <MdArrowDownward size={20} />
                        </button> : null}
                        <ReactTooltip place="top" type="light" effect="float" />
                    </div>
                    <div className="chat__maximized__actions-box">
                        <button className="chat__maximized__actions-send btn-link btn-link-black"
                            onClick={this.sendMessage}>
                            <span className="kr kr-send" />
                        </button>
                        <textarea onKeyPress={this.sendMessage}
                            onChange={this.handleMessageChange}
                            className="message-input" name="message"
                            value={message} placeholder="Type your message" />
                    </div>
                </div>
            </div>
        )
    }

    searchDentist = (e) => {
        const { searchedValue } = this.state;
        const { chatData: { chatDentists } } = this.props;
        const upperCaseValue = searchedValue.replace(/\b(\w)/g, x => { return x.toUpperCase(); })
        const sortedDentists = chatDentists.map(dentist => ({
            ...dentist,
            first_name: dentist.first_name.toLowerCase().replace(/\b(\w)/g, x => { return x.toUpperCase(); }),
            last_name: dentist.last_name.toLowerCase().replace(/\b(\w)/g, x => { return x.toUpperCase(); })
        }
        ))
        if (e.key === "Enter" || e.target.alt === "search") {
            const searchedDentist = sortedDentists.filter(dentist => dentist.first_name == upperCaseValue || dentist.last_name == upperCaseValue || (dentist.first_name + ' ' + dentist.last_name) == upperCaseValue);
            this.setState({
                dentists: searchedDentist,
            })
        }
    }

    handleSearchChange = (e) => {
        const searchedValue = e.target.value;
        this.setState({
            searchedValue
        })
        if (!searchedValue) {
            this.setState({
                dentists: this.props.chatData.chatDentists
            })
        }
    }

    renderDentistsList = () => {
        const { showDentistList, dentists } = this.state;
        const { chatData } = this.props;
        const yetNotRead = chatData.chatDentists.filter(dentist => dentist.unread_messages_count);
        // if(!this.state.isCalendarClosed){
        //     this.props.setCalendarClosed(true);
        // }
        return <div className="chat__maximized">
            <div className="chat__maximized-title">
                <div className="chat__maximized-partner">
                    Choose Dentist
                    </div>
                <div className="chat__maximized-icons">
                    <span
                        className="kr kr-close"
                        onClick={this.props.toggleMinimizedState}
                    />
                </div>
            </div>
            <div className="chat__maximized-list">
                <div
                    className="text-field"
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <input
                        className="text-field__input"
                        type="text"
                        placeholder='Search'
                        onKeyDown={(e) => this.searchDentist(e)}
                        onChange={(e) => this.handleSearchChange(e)}
                    />
                    <img
                        className="enter-name"
                        src={require("../Table/search.svg")}
                        alt="search"
                        onClick={(e) => this.searchDentist(e)}
                        key="Enter"
                    />
                </div>
                <ul onMouseDown={(e) => e.stopPropagation()} className='dentists-list'>
                    {dentists.map(dentist => (
                        <li
                            key={dentist.id}
                            onClick={this.openMessageBlock.bind(null, dentist)}
                        >
                            {`${dentist.first_name} ${dentist.last_name}`}
                            {
                                yetNotRead.map(yetNotRead => (
                                    yetNotRead.id === dentist.id && <span key={yetNotRead.id}>
                                    {dentist.unread_messages_count}
                                </span>
                                ))
                            }
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    }

    renderMaxChatOrDentistList() {
        const { showDentistList } = this.state;
        return showDentistList ?
            this.renderDentistsList()
            :
            this.renderMaximizedChat()
    }

    render() {
        const {
            isMinimized,
            hasNotification,
        } = this.props;
        const { showDentistList } = this.state;
        return <div id="chat-widget">
            {this.renderMinimizedChat()}
            {!isMinimized ?
                <Rnd
                    disableDragging={true}
                    minWidth={300}
                    minHeight={400}
                    style={style}
                    size={{ width: this.state.width, height: this.state.height }}
                    position={{ x: this.state.x, y: this.state.y }}
                    onDragStop={(e, d) => {
                        this.setState({ x: d.x, y: d.y });
                    }}
                    bounds="body"
                    onResizeStop={(e, direction, ref, delta, position) => {
                        this.setState({
                            width: ref.style.width,
                            height: ref.style.height,
                            ...position
                        });
                    }}
                >
                    {this.renderMaxChatOrDentistList()}
                </Rnd> : ''
            }
            <SoundNotification resetHasNotification={this.props.resetHasNotification}
                hasNotification={hasNotification} />
        </div>
    }
}
const mapStateToProps = (state) => ({
    chatData: state.chatData,
    adminCasesState: state.adminCases,
})
const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentDentist: (dentist) => dispatch(setCurrentDentist(dentist)),
        eventOnRead: () => dispatch(eventOnRead()),
        getChatDentists: () => dispatch(getChatDentists()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminChatBox)


// WEBPACK FOOTER //
// ./src/components/Chat/adminChatBox.js